import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getProceedingValidationOptions,
  useValidateProceeding,
} from '@/module/Author/Proceeding/Validation/model/ProceedingValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  proceedingId: Id;
  variant?: ValidationVariant;
}

export function ProceedingValidationAction({ proceedingId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getProceedingValidationOptions(proceedingId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateProceeding(proceedingId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
